import { PropsWithChildren } from "react";
import { useDevice } from "@/utils/hooks";
import { MobileLabel } from "./Candidates.styled";

export function Label(props: PropsWithChildren) {
  const hasMobile = useDevice("down", "md");

  return hasMobile ? <MobileLabel>{props.children}</MobileLabel> : null;
}
